import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PrivateLayout from './Private';
import PublicLayout from './Public';
import { GlobalContext } from 'store/context/GlobalContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { getTime } from 'services/authService';
import ComingSoon from 'pages/ComingSoon';
import LightBox from 'components/LightBox';
import ConfirmBox from 'components/ConfirmBox';
import Clipboard from 'react-clipboard.js';
import useGa from 'hooks/useGa';

function Layout(props) {
    let mounted = true;
    const gaTracking = useGa();
    const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
    const { children } = props;
    const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
    const context = useContext(GlobalContext);
    const { pageTime, setPageTime } = context;
    const [ loading, setLoading ] = useState(isProd ? true : false);
    const [ browserLightbox, setBrowserLightbox ] = useState(false);
    const [ copySuccessConfirmbox, setCopySuccessConfirmbox ] = useState(false);

    useEffect(() => {
        if(pageTime.msg_type !== "00" && pageTime.result){
            alert(pageTime.msg);
        }
    }, [pageTime])

    useEffect(() => {
        let browser = navigator.userAgent,
        isLineApp = browser.indexOf("Line") > -1, // Line 內建瀏覽器
        isFbApp = browser.indexOf("FBAN") > -1 || browser.indexOf("FBAV") > -1, // FB App 內建瀏覽器
        isInstagram = browser.indexOf('Instagram') > -1; // Instagram 內建瀏覽器
        (isLineApp || isFbApp || isInstagram) && setTimeout(() => {
            setBrowserLightbox(true);
        }, 500)
    }, [])

    const fetchTime = useCallback(async() => {
        isProd && setLoading(true);
        let result = await getTime();
        if(mounted){
            setPageTime(result);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        fetchTime();
        return () => mounted = false;
    }, [fetchTime])

    if(loading) return(<></>)

    return (<>
        {
            pageTime.msg_type === "00" ? (
                <ComingSoon />
            ) : (
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ? process.env.REACT_APP_GOOGLE_CLIENT_ID : ""}>
                    <PublicLayout {...props}>{children}</PublicLayout>
                    <LightBox
                        open={browserLightbox}
                        className="browserLightbox"
                        callback={() => setBrowserLightbox(false)}
                    >
                        <div className="light-box-body text-center">
                            <div className="text">
                                <div>為確保活動順暢進行</div>
                                <div>請使用Chrome或其他瀏覽器</div>
                            </div>
                            <div className="info">
                                <div className="d-flex align-items-center mgb-3">按<div className="common-btn yellow mgl-1">複製連結</div></div>
                                <div className="d-flex align-items-center mgb-3">
                                    <div className="triangle"></div>
                                    <div>
                                        <div>開啟</div><div>瀏覽器</div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mgb-3">
                                    <div className="triangle"></div>
                                    <div>
                                        <div>貼上</div><div>連結</div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mgb-3">
                                    <div className="triangle"></div>
                                    <div>
                                        <div>進入</div><div>活動頁</div>
                                    </div>
                                </div>
                            </div>
                            <Clipboard
                                className="common-btn yellow mgt-5 mgb-8"
                                data-clipboard-text={window.location.href}
                                onSuccess={() => {
                                    gaTracking("copy-link");
                                    setCopySuccessConfirmbox(true);
                                }}
                            >
                                複製連結
                            </Clipboard>
                        </div>
                    </LightBox>
                    <ConfirmBox
                        toggle={copySuccessConfirmbox}
                        setToggle={setCopySuccessConfirmbox}
                        confirmCallback={() => gaTracking("copy-link-success")}
                        confirmText="複製成功"
                        confirm={{show: true, text: '確定'}}
                        cancel={{show: false, text: "取消"}}
                    />
                </GoogleOAuthProvider>
            )
        }
    </>)
}
  
export default withRouter(Layout);